<template>
  <router-view />
</template>

<script>
export default {
  name: "EmployeesIndex",
};
</script>